import { SvgIcon } from '@mui/material'
import React from 'react'

const ChartBarIcon: React.FC<{
  fontSize?: string
}> = ({ fontSize = '40px' }) => {
  return (
    <SvgIcon sx={{ fontSize }}>
      <svg
        width="56"
        height="20"
        viewBox="0 0 56 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="12" width="2" height="8" fill="#001DE0" />
        <rect x="9.5" y="4" width="2" height="16" fill="#001DE0" />
        <rect x="18.5" y="8" width="2" height="12" fill="#001DE0" />
        <rect x="44.5" width="2" height="20" fill="#001DE0" />
        <rect x="35.5" y="14" width="2" height="6" fill="#001DE0" />
        <rect x="53.5" y="4" width="2" height="16" fill="#001DE0" />
      </svg>
    </SvgIcon>
  )
}

export default ChartBarIcon
